/*
 * Hack while waiting for https://github.com/angular/angular/issues/6595 to be fixed.
 */

import { Directive, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHashListener]',
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[style.position]': "'relative'",
  },
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class HashListener implements OnDestroy, OnInit {
  sub: Subscription;

  constructor(private route: ActivatedRoute) {
    this.sub = this.route.fragment.subscribe((f) => {
      if (f) {
        this.scrollToAnchor(f, false);
      }
    });
  }

  ngOnInit() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.scrollToAnchor(this.route.snapshot.fragment!, false);
  }

  scrollToAnchor(hash: string, smooth = true) {
    if (hash) {
      const element = document.querySelector('#' + hash);
      if (element) {
        element.scrollIntoView({
          behavior: smooth ? 'smooth' : 'instant',
          block: 'start',
        } as ScrollIntoViewOptions);
      }
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
